import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { SrDialog, Typography } from "../../../../common";
import translate from "../../../../../i18n/translate";
import { FEES } from "../../../../../constants";

const useStyles = makeStyles((theme) => ({
  month: {
    position: "relative",
    marginLeft: theme.spacing(1.5),
    "&:before": {
      content: "''",
      backgroundColor: theme.palette.info.main,
      display: "block",
      width: theme.spacing(0.9),
      height: theme.spacing(0.9),
      borderRadius: "50%",
      position: "absolute",
      left: -theme.spacing(1.5),
      top: theme.spacing(0.9),
    },
  },
  modalList: {
    listStyle: "none",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    maxWidth: "250px",
    margin: "0 auto",
    fontWeight: theme.typography.fontWeightMedium,
    padding: 0,
    "& li": {
      display: "flex",
      justifyContent: "space-between",
    },
  },
  divider: {
    border: "none",
    height: "1px",
    backgroundColor: theme.palette.divider,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
}));

const ComissionDialog = ({ isOpen, onClose }) => {
  const classes = useStyles();

  return (
    <SrDialog
      heading={translate("resume.comisions")}
      maxWidth="xs"
      open={isOpen}
      handleClose={onClose}
    >
      <Typography>
        {translate("resume.comissionsRateDescription", { fee: FEES.GENERAL })}
      </Typography>
      <hr className={classes.divider} />
      <ul className={classes.modalList}>
        <li>
          <div className={classes.month}>
            {translate("resume.intrestRateThreeMonths")}
          </div>
          <div>{FEES.THREE_MONTHS_INTEREST_FREE}</div>
        </li>
        <li>
          <div className={classes.month}>
            {translate("resume.intrestRateSixMonths")}
          </div>
          <div>{FEES.SIX_MONTHS_INTEREST_FREE}</div>
        </li>
        <li>
          <div className={classes.month}>
            {translate("resume.intrestRateNineMonths")}
          </div>
          <div>{FEES.NINE_MONTHS_INTEREST_FREE}</div>
        </li>
        <li>
          <div className={classes.month}>
            {translate("resume.intrestRateTwelveMonths")}
          </div>
          <div>{FEES.TWELVE_MONTHS_INTEREST_FREE}</div>
        </li>
      </ul>
    </SrDialog>
  );
};

export default ComissionDialog;
